import React from 'react';

export const PageScrollContext = React.createContext({
	alignByElementBottom: (elementBottom: number) => {
	}
});
